module.exports = __webpack_public_path__ + "img/80B.3655854f.png";